/**
 * Client-side edge visibility for the KG canvas (show links toggle).
 * Entity/group/search filtering is server-driven via kg/entities query params.
 */

import { useMemo } from "react";
import type { KgFlowEdge, KgFlowNode } from "../types";

export interface UseKgGraphFiltersResult {
  visibleNodes: KgFlowNode[];
  visibleEdges: KgFlowEdge[];
}

export const useKgGraphFilters = (
  nodes: KgFlowNode[],
  edges: KgFlowEdge[],
  showLinks: boolean,
): UseKgGraphFiltersResult => {
  const visibleEdges = useMemo(() => {
    if (!showLinks) return [];
    const ids = new Set(nodes.map((n) => n.id));
    return edges.filter((e) => ids.has(e.source) && ids.has(e.target));
  }, [edges, nodes, showLinks]);

  return {
    visibleNodes: nodes,
    visibleEdges,
  };
};
